import { type SvgProps, SvgWrapper } from '../utils';

export function PlusIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V10.25H20C20.4142 10.25 20.75 10.5858 20.75 11C20.75 11.4142 20.4142 11.75 20 11.75H12.75V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V11.75H4C3.58579 11.75 3.25 11.4142 3.25 11C3.25 10.5858 3.58579 10.25 4 10.25H11.25V3C11.25 2.58579 11.5858 2.25 12 2.25Z" />
    </SvgWrapper>
  );
}
